import "./../styles/main.scss";
// JQuery Ecosystem
import $ from "jquery";
import GLightbox from "glightbox";
require("./helpers/jQueryPlugins");
require("jquery.scrollto");
const axios = require('axios').default;
import { carouselWrapper } from "./helpers/CarouselWrapper";
import Choices from "choices.js";
import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
// GDPR Custom System
// require ('./helpers/CookieConsent');
$(document).ready(function () {
    $("body").on("click", ".offer-item .header a", (e) => {
        e.preventDefault();
        $(e.currentTarget).parent().parent().next(".text").slideToggle(250);
        $(e.currentTarget).toggleClass("open");
    });
    $.extend($.scrollTo.defaults, {
        axis: 'y',
        duration: 250
    });
    $('body').on("click", ".switchers .switcher", (e) => {
        e.preventDefault();
        $("#big-menu").fadeIn(250);
    });
    $('body').on("click", "#big-menu .close a", (e) => {
        e.preventDefault();
        $("#big-menu").fadeOut(250);
    });
    const lightbox = GLightbox({});
    carouselWrapper();
    $("body").on("click", "#more-filters", (e) => {
        e.preventDefault();
        $(e.currentTarget).toggleClass("opened");
        // $("#simple-submit-button").hide(0);
        $("#properties-form").find(".second-level").slideToggle(250);
    });
    $("#properties-form select").each((e, v) => {
        let choices = new Choices(v, {
            removeItemButton: true,
            loadingText: 'Loading...',
            noResultsText: 'Aucun résultat trouvé',
            noChoicesText: 'Aucun choix disponible',
            itemSelectText: 'Presser pour séléctionner',
            uniqueItemText: 'Seulement une seule valeur peut etre ajoutée',
            shouldSort: false,
            // customAddItemText: 'Only values matching specific conditions can be added',
            addItemText: (value) => {
                return `Appuyez sur retour pour ajouter <b>"${value}"</b>`;
            },
            maxItemText: (maxItemCount) => {
                return `Seulement ${maxItemCount} valeurs peuvent être ajoutées.`;
            },
        });
    });
    $('.goal-item input').on("change", (e) => {
    });
    $("body").on("click", "a[data-goto]", (e) => {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href");
        if (node.length) {
            const posY = $(node).offset().top - $("#main-header").height();
            if (posY >= 0) {
                $.scrollTo(posY, 400);
            }
        }
    });
    $('body').on("click", ".shared-item", (e) => {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", (e) => {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $("body").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo, a[href^='#']", (e) => {
        e.preventDefault();
        const elm = $(e.currentTarget).attr("href");
        if ($(elm).length) {
            const posY = $(elm).offset().top - ($("#main-header").height());
            $.scrollTo(posY, 400);
        }
    });
    $("body").on("click", "*[data-link]", (e) => {
        document.location = $(e.currentTarget).attr("data-link");
    });
    if ($("#map").length) {
        if ($(window).width() < 950) {
            $('.properties-content-page').toggleClass("hide-map");
            $('#properties-list').removeClass("by-two").addClass("by-four");
        }
        $('.properties-content-page').on("click", ".actions a", (e) => {
            e.preventDefault();
            $('.properties-content-page').toggleClass("hide-map");
            if ($(e.currentTarget).hasClass("close-map")) {
                $('#properties-list').removeClass("by-two").addClass("by-four");
            }
            else if ($(e.currentTarget).hasClass("open-map")) {
                $('#properties-list').addClass("by-two").removeClass("by-four");
            }
        });
        const apiKey = $("#map").attr("data-uid");
        const loader = new Loader({
            apiKey: apiKey,
            version: "weekly",
            libraries: []
        });
        let mapStyled = [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#c0eea4" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#a6edf1" }] }];
        const mapOptions = {
            center: {
                lat: 50.454241,
                lng: 3.956659
            },
            zoom: 9,
            maxZoom: 16,
            mapTypeControl: false,
            fullscreenControl: false,
            styles: mapStyled
        };
        loader
            .load()
            .then((google) => {
            let map = new google.maps.Map(document.getElementById("map"), mapOptions);
            if ($(".agent-item").length) {
                let children = $('.agent-item').length;
                let agents = [];
                let agentsArr = [];
                let infowindowElmA = null;
                $('.agent-item').each((k, v) => {
                    $(v).addClass("item-" + k);
                    let content = $(v).html();
                    let elm = $(v);
                    if (elm.attr("data-locations") !== void 0) {
                        let locations = elm.attr("data-locations");
                        $.each(locations.split(";"), function (k, v) {
                            let coords = v.split(",");
                            if (!isNaN(parseFloat(coords[0])) && !isNaN(parseFloat(coords[1]))) {
                                let latLng = { lat: parseFloat(coords[0]), lng: parseFloat(coords[1]) };
                                let point = new google.maps.LatLng(parseFloat(coords[0]), parseFloat(coords[1]));
                                let marker = new google.maps.Marker({
                                    position: latLng,
                                    icon: "/app/themes/lumber/static/gfx/icons/picto_map_orange.svg"
                                });
                                marker.setMap(map);
                                agents.push(marker);
                                agentsArr.push({
                                    lat: parseFloat(coords[0]),
                                    lng: parseFloat(coords[1]),
                                    elm: elm
                                });
                                let infowindow = new google.maps.InfoWindow({
                                    content: `<div class="pop-up-map">${content}</div>`,
                                    disableAutoPan: true
                                });
                                marker.addListener("click", (e) => {
                                    if (infowindowElmA != null)
                                        infowindowElmA.close();
                                    infowindow.open({
                                        anchor: marker,
                                        map,
                                        shouldFocus: false
                                    });
                                    infowindowElmA = infowindow;
                                    map.panTo(point);
                                });
                            }
                        });
                    }
                    if (k == (children - 1)) {
                        const markerCluster = new MarkerClusterer({ map: map, markers: agents });
                    }
                });
            }
            if ($(".office-item").length) {
                let children = $('.office-item').length;
                let offices = [];
                let officesArr = [];
                let infowindowElmO = null;
                $('.office-item').each((k, v) => {
                    $(v).addClass("item-" + k);
                    let content = $(v).html();
                    let elm = $(v);
                    // content.find(".action").remove();
                    if (!isNaN(parseFloat($(v).attr("data-lat"))) && !isNaN(parseFloat($(v).attr("data-lng")))) {
                        let latLng = { lat: parseFloat($(v).attr("data-lat")), lng: parseFloat($(v).attr("data-lng")) };
                        let point = new google.maps.LatLng(parseFloat($(v).attr("data-lat")), parseFloat($(v).attr("data-lng")));
                        let marker = new google.maps.Marker({
                            position: latLng,
                            icon: "/app/themes/lumber/static/gfx/icons/picto_map_bleu.svg"
                        });
                        marker.setMap(map);
                        offices.push(marker);
                        officesArr.push({
                            lat: parseFloat($(v).attr("data-lat")),
                            lng: parseFloat($(v).attr("data-lng")),
                            elm: elm
                        });
                        let infowindow = new google.maps.InfoWindow({
                            content: `<div class="pop-up-map">${content}</div>`,
                            disableAutoPan: true
                        });
                        marker.addListener("click", (e) => {
                            if (infowindowElmO != null)
                                infowindowElmO.close();
                            infowindow.open({
                                anchor: marker,
                                map,
                                shouldFocus: false
                            });
                            infowindowElmO = infowindow;
                            map.panTo(point);
                        });
                    }
                    if (k == (children - 1)) {
                        const markerCluster = new MarkerClusterer({ map: map, markers: offices });
                    }
                });
            }
            if ($(".property-item").length) {
                let children = $('.property-item').length;
                let markers = [];
                let markersArr = [];
                let bounds = new google.maps.LatLngBounds();
                let infowindowElm = null;
                $('.property-item').each((k, v) => {
                    $(v).addClass("item-" + k);
                    $(v).parent().addClass("property-item-parent");
                    let content = $(v).parent().html();
                    let elm = $(v);
                    // content.find(".action").remove();
                    if (!isNaN(parseFloat($(v).attr("data-lat"))) && !isNaN(parseFloat($(v).attr("data-lng")))) {
                        let latLng = { lat: parseFloat($(v).attr("data-lat")), lng: parseFloat($(v).attr("data-lng")) };
                        // Fit zoom and map to all elements
                        let point = new google.maps.LatLng(parseFloat($(v).attr("data-lat")), parseFloat($(v).attr("data-lng")));
                        bounds.extend(point);
                        let marker = new google.maps.Marker({
                            position: latLng,
                            icon: "/app/themes/lumber/static/gfx/icons/pin.svg"
                        });
                        marker.setMap(map);
                        markers.push(marker);
                        markersArr.push({
                            lat: parseFloat($(v).attr("data-lat")),
                            lng: parseFloat($(v).attr("data-lng")),
                            elm: elm
                        });
                        let infowindow = new google.maps.InfoWindow({
                            content: `<div class="pop-up-map">${content}</div>`,
                            disableAutoPan: true
                        });
                        marker.addListener("click", (e) => {
                            if (infowindowElm != null)
                                infowindowElm.close();
                            infowindow.open({
                                anchor: marker,
                                map,
                                shouldFocus: false
                            });
                            infowindowElm = infowindow;
                            map.panTo(point);
                        });
                    }
                    //
                    if (k == (children - 1)) {
                        const markerCluster = new MarkerClusterer({ map, markers });
                        let isScrolling = false;
                        google.maps.event.addListener(map, 'bounds_changed', function () {
                            var bounds = map.getBounds();
                            var ne = bounds.getNorthEast();
                            var sw = bounds.getSouthWest();
                            let mapIsHidden = $('.hide-map').length;
                            markersArr.forEach((v) => {
                                let element = v;
                                let inViewport = ((element.lat < ne.lat() && element.lat > sw.lat()) && (element.lng < ne.lng() && element.lng > sw.lng()));
                                if (inViewport || mapIsHidden)
                                    element.elm.parent().removeClass("property-hidden");
                                else if (!inViewport)
                                    element.elm.parent().addClass("property-hidden");
                            });
                        });
                        google.maps.event.addListener(map, 'drag', function () {
                            if (isScrolling == false) {
                                isScrolling = true;
                                $("body").scrollTo($(".properties-content-page").offset().top - $("#main-header").height() + 2, 150, () => {
                                    isScrolling = false;
                                });
                            }
                        });
                        if ($("#city").hasClass("fit"))
                            map.fitBounds(bounds);
                    }
                });
            }
            $("body").on("click", "a[href='#view-on-map']", (e) => {
                e.preventDefault();
                map.panTo(new google.maps.LatLng(parseFloat($(e.currentTarget).parent().parent().attr("data-lat")), parseFloat($(e.currentTarget).parent().parent().attr("data-lng"))));
                map.setZoom(9);
            });
        })
            .catch(e => {
        });
    }
    if ($("#epc1").length) {
        $('#epc1').epcSlider({
            min: 0,
            max: 700,
            val: parseInt($("#epc1").attr("data-value"))
        });
    }
});
